import comp from "./CategoryTemplate";
export default comp;
